var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512.001 512.001",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M10.071,24.912V237.98c0,8.781,7.119,15.901,15.901,15.901h77.383l59.362,67.843V253.88H240.1 c8.781,0,15.901-7.119,15.901-15.901V24.912c0-8.781-7.119-15.901-15.901-15.901H25.971C17.19,9.011,10.071,16.13,10.071,24.912z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF8C78"
    },
    points: "128.795,75.793 60.953,109.715 60.953,219.959 111.835,219.959 111.835,160.597 145.756,160.597 145.756,219.959 196.638,219.959 196.638,109.715 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DF7A6E"
    },
    points: "60.953,109.715 60.953,219.959 86.924,219.959 86.924,96.729 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBE8C8"
    },
    cx: 480.729,
    cy: 179.678,
    r: 21.201
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBE8C8"
    },
    cx: 243.28,
    cy: 179.678,
    r: 21.201
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBE8C8"
    },
    cx: 362.004,
    cy: 154.237,
    r: 110.244
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD791"
    },
    d: "M281.441,154.237c0-55.853,41.537-101.997,95.404-109.247c-4.855-0.653-9.808-0.998-14.841-0.998 c-60.887,0-110.244,49.358-110.244,110.244s49.358,110.244,110.244,110.244c5.033,0,9.986-0.345,14.841-0.997 C322.978,256.234,281.441,210.089,281.441,154.237z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#666666"
    },
    d: "M362.004,7.951c0,0-122.965,16.961-122.965,127.205 c0,42.402,20.594,65.855,33.921,84.08v-67.12l76.058-32.596l-8.215,41.077l72.893-40.496l37.352,32.015v67.12 c13.327-18.226,33.921-41.679,33.921-84.08C484.969,24.912,362.004,7.951,362.004,7.951z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#666666"
    },
    d: "M362.004,7.951c0,0-122.965,16.961-122.965,127.205 c0,42.402,20.594,65.855,33.921,84.08v-67.12l76.058-32.596l-8.215,41.077l72.893-40.496l37.352,32.015v67.12 c13.327-18.226,33.921-41.679,33.921-84.08C484.969,24.912,362.004,7.951,362.004,7.951z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C"
    },
    d: "M272.961,135.156c0-84.522,72.277-114.211,106.004-123.464c-10.264-2.815-16.961-3.741-16.961-3.741 S239.04,24.912,239.04,135.156c0,42.402,20.594,65.855,33.921,84.08v-67.12l1.113-0.477 C273.365,146.477,272.961,141.003,272.961,135.156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M489.209,504.05h-254.41V306.883c0-17.564,14.237-31.801,31.801-31.801h190.807 c17.564,0,31.801,14.237,31.801,31.801V504.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5E5E5"
    },
    d: "M266.601,275.081c-17.564,0-31.801,14.237-31.801,31.801V504.05h172.864L275.603,275.081H266.601z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C4DF64"
    },
    points: "330.203,275.081 393.806,275.081 381.085,323.843 342.924,323.843 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C4DF64"
    },
    points: "391.686,451.048 362.004,474.369 332.323,451.048 342.924,323.843 381.085,323.843 "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#96CA63"
    },
    points: "381.085,323.843 342.924,323.843 340.981,347.164 383.028,347.164 "
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.756,227.909h50.882c4.391,0,7.95-3.56,7.95-7.95V109.715c0-3.012-1.701-5.765-4.395-7.111l-67.843-33.921 c-2.238-1.119-4.873-1.119-7.111,0l-67.843,33.921c-2.694,1.346-4.395,4.099-4.395,7.111v110.244c0,4.391,3.56,7.95,7.95,7.95 h50.882c4.391,0,7.95-3.56,7.95-7.95v-51.412h18.021v51.412C137.806,224.35,141.365,227.909,145.756,227.909z M111.835,152.646 c-4.391,0-7.95,3.56-7.95,7.95v51.412H68.903v-97.381l59.892-29.946l59.892,29.946v97.381h-34.981v-51.412 c0-4.391-3.56-7.95-7.95-7.95H111.835z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M222.072,100.706c2.815,0,5.543-1.499,6.987-4.145c2.103-3.854,0.683-8.684-3.173-10.786l-93.284-50.882 c-2.372-1.295-5.241-1.295-7.614,0L31.704,85.775c-3.854,2.102-5.276,6.932-3.173,10.786c2.102,3.854,6.933,5.275,10.786,3.173 l89.478-48.805l89.477,48.805C219.481,100.394,220.786,100.706,222.072,100.706z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M455.171,226.977c0.405-0.518,4.667-6.256,5.918-7.93c2.817-3.767,5.851-7.833,8.888-12.277 c3.406,1.349,7.058,2.06,10.751,2.06c16.074,0,29.151-13.077,29.151-29.151c0-11.856-7.243-22.522-18.138-26.973 c0.754-5.496,1.178-11.33,1.178-17.549c0-48.056-22.619-86.718-65.412-111.803C395.766,4.745,364.411,0.257,363.091,0.075 c-0.722-0.1-1.451-0.1-2.173,0c-1.32,0.182-32.675,4.671-64.417,23.277c-12.635,7.408-23.496,16.007-32.551,25.673V24.912 c0-13.152-10.699-23.851-23.851-23.851h-26.501c-4.391,0-7.95,3.56-7.95,7.95s3.56,7.95,7.95,7.95H240.1 c4.384,0,7.95,3.566,7.95,7.95v44.522c0,0.222,0.016,0.439,0.033,0.656c-11.218,18.937-16.994,40.801-16.994,65.066 c0,6.216,0.423,12.046,1.177,17.541c-10.764,4.407-18.137,15.014-18.137,26.981c0,16.074,13.077,29.151,29.151,29.151 c1.608,0,3.2-0.147,4.77-0.407v29.558c0,4.384-3.566,7.95-7.95,7.95h-77.383c-4.391,0-7.95,3.56-7.95,7.95v46.683l-45.428-51.919 c-1.511-1.725-3.691-2.715-5.984-2.715H25.971c-4.384,0-7.95-3.566-7.95-7.95V24.912c0-4.384,3.566-7.95,7.95-7.95h145.226 c4.391,0,7.95-3.56,7.95-7.95s-3.56-7.95-7.95-7.95H25.971C12.819,1.061,2.12,11.76,2.12,24.912V237.98 c0,13.152,10.699,23.851,23.851,23.851h73.776l56.987,65.128c4.738,5.415,13.934,1.929,13.934-5.236v-59.892h69.433 c13.152,0,23.851-10.699,23.851-23.851v-17.551c0.886,1.187,4.47,6.015,4.887,6.548c15.11,19.328,35.315,33.128,58,40.154h-60.238 c-21.92,0-39.752,17.832-39.752,39.752v99.644c0,4.391,3.56,7.95,7.95,7.95s7.95-3.56,7.95-7.95v-99.644 c0-13.152,10.699-23.851,23.851-23.851h57.46l10.827,41.505l-10.488,125.851c-0.222,2.664,0.91,5.261,3.011,6.913l29.681,23.321 c2.849,2.239,6.974,2.239,9.824,0l29.681-23.321c2.101-1.652,3.233-4.249,3.011-6.913l-10.488-125.851l10.829-41.505h57.46 c13.152,0,23.851,10.699,23.851,23.851V496.1H242.75v-47.172c0-4.391-3.56-7.95-7.95-7.95s-7.95,3.56-7.95,7.95v55.122 c0,4.391,3.56,7.95,7.95,7.95h254.41c4.391,0,7.95-3.56,7.95-7.95V306.883c0-21.92-17.832-39.752-39.752-39.752H397.17 C419.856,260.106,440.062,246.304,455.171,226.977z M493.98,179.678c0,8.07-7.448,14.352-15.39,13.057 c3.795-7.041,7.222-14.926,9.774-23.878C491.816,171.3,493.98,175.31,493.98,179.678z M230.029,179.678 c0-4.4,2.193-8.393,5.616-10.821c2.554,8.957,5.983,16.847,9.781,23.891C237.481,194.042,230.029,187.737,230.029,179.678z M265.011,152.116v42.463c-9.546-14.685-18.021-33.12-18.021-59.424c0-42.534,19.223-75.453,57.135-97.84 c25.885-15.285,52.252-20.363,57.879-21.315c5.628,0.951,31.994,6.031,57.879,21.315c37.912,22.387,57.135,55.306,57.135,97.84 c0,26.304-8.475,44.739-18.021,59.424v-42.463c0-2.32-1.014-4.526-2.776-6.036l-37.352-32.015c-2.496-2.14-6.16-2.511-9.035-0.914 l-57.865,32.147l4.843-24.219c1.231-6.156-5.153-11.338-10.928-8.866l-76.058,32.596 C266.906,146.062,265.011,148.936,265.011,152.116z M362.004,464.258l-21.402-16.816l9.637-115.648h23.531l9.637,115.648 L362.004,464.258z M374.943,315.893h-25.877l-8.573-32.861h43.022L374.943,315.893z M362.004,256.531 c-31.698,0-61.09-14.341-80.639-39.347c-0.144-0.184-0.297-0.355-0.454-0.524v-59.302l57.348-24.578l-5.251,26.257 c-1.301,6.501,5.846,11.741,11.657,8.509l68.058-37.81l30.374,26.037v60.887c-0.156,0.167-0.31,0.339-0.454,0.524 C423.095,242.189,393.703,256.531,362.004,256.531z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M375.034,209.53c-5.148,4.15-10.827,4.598-13.03,4.598c-6.611,0-11.316-3.217-13.031-4.6 c-3.42-2.755-8.424-2.217-11.179,1.2c-2.755,3.419-2.218,8.424,1.2,11.179c3.762,3.033,11.755,8.121,23.01,8.121 c4.833,0,14.247-1.056,23.011-8.122c3.418-2.756,3.954-7.762,1.198-11.179C383.458,207.311,378.453,206.774,375.034,209.53z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M410.766,173.847h-5.3c-4.391,0-7.95,3.56-7.95,7.95s3.56,7.95,7.95,7.95h5.3c4.391,0,7.95-3.56,7.95-7.95 S415.157,173.847,410.766,173.847z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M318.543,173.847h-5.3c-4.391,0-7.95,3.56-7.95,7.95s3.56,7.95,7.95,7.95h5.3c4.391,0,7.95-3.56,7.95-7.95 S322.933,173.847,318.543,173.847z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.72e7fd683f3fb76b95f71a412b426948.svg";
export { ForwardRef as ReactComponent };